module.exports = __webpack_public_path__ + "static/img/jt2.cae5c03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/jt2.jpg
// module id = Goh5
// module chunks = 1